import { aqoraClient } from '~/services/api/aqora-client';

export const getStatistics = () => aqoraClient.getGeneralStatistics({});
